// extracted by mini-css-extract-plugin
export var progressContainer = "_g1-0";